import { z } from 'zod'

export const nativeGoalSchema = z.object({
  goal: z.string(),
  status: z.enum(['active', 'paused', 'done', 'cleared']),
  turns_used: z.number().int().nonnegative(),
  max_turns: z.number().int().positive(),
  last_reason: z.string().nullable(),
  paused_reason: z.string().nullable(),
  waiting_until: z.number(),
  consecutive_parse_failures: z.number().int().nonnegative(),
  consecutive_transport_failures: z.number().int().nonnegative(),
})
export const goalSnapshotSchema = z.object({
  id: z.uuid(),
  objective: z.string(),
  state: z.enum(['active', 'waiting', 'paused', 'blocked', 'done', 'stopped']),
  reason: z.string().nullable(),
  native_state: nativeGoalSchema.nullable(),
  next_check_at: z.string(),
  deadline: z.string(),
})
export type GoalSnapshot = z.infer<typeof goalSnapshotSchema>

export const goalInputSchema = z.strictObject({
  objective: z.string().trim().min(1).max(8000),
  verification: z.string().trim().min(1).max(4000),
  constraints: z.string().max(4000).default(''),
  duration_hours: z.number().min(1).max(168).default(12),
})
